import { DateView, PickersLayout } from "@mui/x-date-pickers";
import { Paper, styled } from "@mui/material";
import { Dayjs } from "dayjs";

export const StyledPaper = styled(Paper)`
  box-shadow: none;
  background: none;
`;

export const StyledPickersLayout = styled(
  PickersLayout<Dayjs | null, Dayjs, DateView>,
)`
  color: ${(props) => props.theme.wsc.palette.neutral[100]};
  border-radius: ${(props) => props.theme.wsc.radius.m};
  border: 1px solid ${(props) => props.theme.wsc.palette.neutral[700]};
  background-color: ${(props) => props.theme.wsc.palette.neutral[800]};

  .MuiDateCalendar-root {
    width: 24rem;
    height: 27.857rem;
    max-height: 27.857rem;

    .MuiPickersSlideTransition-root {
      min-height: 19rem;
    }

    .MuiDayCalendar-weekDayLabel,
    .MuiPickersDay-root {
      ${(props) => props.theme.wsc.typography.header5};
      min-width: ${(props) => props.theme.wsc.size.xxl};
      height: ${(props) => props.theme.wsc.size.xxl};
    }

    .MuiDayCalendar-weekDayLabel {
      color: ${(props) => props.theme.wsc.palette.neutral[200]};
    }

    .MuiPickersDay-root {
      color: ${(props) => props.theme.wsc.palette.neutral[100]};

      &.Mui-selected {
        background-color: ${(props) => props.theme.wsc.palette.primary[300]};
        color: ${(props) => props.theme.wsc.palette.neutral[800]};
      }

      &:not(.Mui-selected) {
        &:focus {
          background: none;
        }

        &:hover {
          background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
        }
      }

      &:disabled {
        color: ${(props) => props.theme.wsc.palette.neutral[400]};
      }
    }

    .MuiPickersDay-today {
      border: 1px solid ${(props) => props.theme.wsc.palette.primary[300]};
    }
  }

  .MuiMonthCalendar-root .MuiPickersMonth-monthButton,
  .MuiYearCalendar-root .MuiPickersYear-yearButton {
    ${(props) => props.theme.wsc.typography.header5};
    width: calc(${(props) => props.theme.wsc.size.m} * 4);
    height: ${(props) => props.theme.wsc.size.xxl};
    padding: 0;
    border-radius: ${(props) => props.theme.wsc.radius.xxl};
    color: ${(props) => props.theme.wsc.palette.neutral[100]};

    &.Mui-selected {
      color: ${(props) => props.theme.wsc.palette.neutral[800]};
      background-color: ${(props) => props.theme.wsc.palette.primary[300]};
    }

    &:not(.Mui-selected):focus {
      background: none;
    }

    &:not(.Mui-selected):hover {
      background-color: ${(props) => props.theme.wsc.palette.neutral[600]};
    }

    &.Mui-disabled {
      color: ${(props) => props.theme.wsc.palette.neutral[400]};
    }
  }

  .MuiMonthCalendar-root {
    width: 100%;
    padding: 0 ${(props) => props.theme.wsc.spacing[4]};

    .MuiPickersMonth-root {
      margin-bottom: ${(props) => props.theme.wsc.spacing[3]};

      .MuiPickersMonth-monthButton {
        margin: 0;
      }
    }
  }

  .MuiYearCalendar-root {
    width: calc(100% - 0.571rem);
    padding: 0 0 0 ${(props) => props.theme.wsc.spacing[2]};

    .MuiPickersYear-root {
      .MuiPickersYear-yearButton {
        margin: ${(props) => props.theme.wsc.spacing[1]} 0;
      }
    }
  }
`;
